import script from "./MyEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./MyEvents.vue?vue&type=script&setup=true&lang=js"

import "./MyEvents.vue?vue&type=style&index=0&id=2c9c45a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9c45a0"]])

export default __exports__